import { Observable } from 'rxjs';
import { Auth, User, onAuthStateChanged, onIdTokenChanged } from 'firebase/auth';

export function authState$(auth: Auth): Observable<User | null> {
  return new Observable<User | null>(subscriber => {
    const unsubscribe = onAuthStateChanged(
      auth,
      user => subscriber.next(user),
      error => subscriber.error(error)
    );

    return () => unsubscribe();
  });
}

export function idToken$(auth: Auth): Observable<string | null> {
  return new Observable<string | null>(subscriber => {
    const unsubscribe = onIdTokenChanged(
      auth,
      async user => {
        if (!user) {
          subscriber.next(null);
          return;
        }

        try {
          subscriber.next(await user.getIdToken());
        } catch (error) {
          subscriber.error(error);
        }
      },
      error => subscriber.error(error)
    );

    return () => unsubscribe();
  });
}
